__turbopack_context__.v({
  "blue1": "logo-module-scss-module__TwMP7G__blue1",
  "blue2": "logo-module-scss-module__TwMP7G__blue2",
  "blue3": "logo-module-scss-module__TwMP7G__blue3",
  "blue4": "logo-module-scss-module__TwMP7G__blue4",
  "blue5": "logo-module-scss-module__TwMP7G__blue5",
  "brand_logo": "logo-module-scss-module__TwMP7G__brand_logo",
  "builderLogo": "logo-module-scss-module__TwMP7G__builderLogo",
  "foot-nav": "logo-module-scss-module__TwMP7G__foot-nav",
  "footer_logo": "logo-module-scss-module__TwMP7G__footer_logo",
  "lock-up": "logo-module-scss-module__TwMP7G__lock-up",
  "logo": "logo-module-scss-module__TwMP7G__logo",
  "logoLink": "logo-module-scss-module__TwMP7G__logoLink",
  "logo_icon": "logo-module-scss-module__TwMP7G__logo_icon",
  "nestingale": "logo-module-scss-module__TwMP7G__nestingale",
  "small-logo": "logo-module-scss-module__TwMP7G__small-logo",
});
